import { Model } from "@vuex-orm/core";
import ListType from "./ListType";

export default class ListItem extends Model {
  static entity = "listItems";

  static fields() {
    return {
      id: this.attr(),
      listTypeId: this.attr(),
      name: this.attr(),
      rank: this.attr(),
      meta: this.attr({}),

      listType: this.belongsTo(ListType, "listTypeId")
    };
  }
}
